import axios from 'redaxios';

const selectors = {
  wrapper: '[data-product-add-popdown-wrapper]',
  closeDrawer: '[data-close-popdown]',
  apiContent: '[data-api-content]',
  cartSectionAjax: '[data-ajax-disable="false"]',
  ajaxDisabled: '[data-ajax-disable="true"]',
};

var globalTimer;

class CartPopdown {
  constructor() {
    this.drawer = document.querySelector(selectors.wrapper);
    this.cartSectionAjax = document.querySelector(selectors.cartSectionAjax);
    this.ajaxDisabled = document.querySelector(selectors.ajaxDisabled);
    document.addEventListener('theme:cart:popdown', (e) => {
      if (this.cartSectionAjax) {
        // if we are on the cart page, refresh the cart without popdown
        this.cartSectionAjax.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
      } else if (this.ajaxDisabled) {
        // ajax is disabled, refresh the whole page
        window.location.reload();
      } else {
        this.renderPopdown(e);
      }
    });
  }

  renderPopdown(event) {
    const variant = event.detail.variant;
    const url = `${window.theme.routes.root_url}variants/${variant.id}/?section_id=api-product-popdown`;
    const instance = this;
    axios
      .get(url)
      .then(function (response) {
        // handle success
        const fresh = document.createElement('div');
        fresh.innerHTML = response.data;
        instance.drawer.innerHTML = fresh.querySelector('[data-api-content]').innerHTML;
        instance.connectCartButton();
        instance.connectCloseButton();
      })
      .catch(function (error) {
        console.warn(error);
      });
  }

  connectCloseButton() {
    // Enable close button
    this.drawer.classList.add('is-visible');
    const closer = this.drawer.querySelector(selectors.closeDrawer);
    closer.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        this.drawer.classList.remove('is-visible');
      }.bind(this)
    );
    this.popdownTimer();
  }

  connectCartButton() {
    // Hook into cart drawer
    const cartButton = this.drawer.querySelector('[data-drawer-toggle="drawer-cart"]');
    const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');

    if (cartDrawer) {
      cartButton.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          this.drawer.classList.remove('is-visible');
          cartDrawer.dispatchEvent(
            new CustomEvent('theme:drawer:open', {
              bubbles: false,
            })
          );
        }.bind(this)
      );
    }
  }

  popdownTimer() {
    clearTimeout(globalTimer);
    globalTimer = setTimeout(() => {
      this.drawer.classList.remove('is-visible');
    }, 5000);
  }
}

const cartPopdown = {
  onLoad() {
    new CartPopdown(this);
  },
};

export default cartPopdown;
